import { useCallback } from 'react';
import { useStytchTotpCreate, useStytchTotpAuthenticate, useStytchSmsOtpSend, useStytchSmsOtpAuthenticate, useStytchRecoveryCodesRecover, useStytchRecoveryCodesRotate, } from '../../../services/stytch/client';
/**
 * Hook to send magic link email for discovery flow
 */
export function useCreateTotp() {
    const createTotp = useStytchTotpCreate();
    return useCallback(async (data) => {
        const result = await createTotp(data);
        if (result.success) {
            return {
                success: true,
                requestId: result.requestId,
                statusCode: result.statusCode,
                secret: result.secret,
                qrCode: result.qrCode,
                recoveryCodes: result.recoveryCodes,
                memberId: result.memberId,
                //organizationId: result.organizationId,
                data: result.data,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
                data: result.data,
            };
        }
    }, [createTotp]);
}
export function useAuthenticateTotp() {
    const authenticateTotp = useStytchTotpAuthenticate();
    return useCallback(async (data) => {
        const result = await authenticateTotp(data);
        if (result.success) {
            return {
                success: true,
                requestId: result.requestId,
                statusCode: result.statusCode,
                memberId: result.memberId,
                //organizationId: result.organizationId,
                sessionJwt: result.sessionJwt,
                sessionToken: result.sessionToken,
                memberSession: result.memberSession,
                member: result.member,
                organization: result.organization,
                data: result.data,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
                data: result.data,
            };
        }
    }, [authenticateTotp]);
}
/**
 * Hook to send magic link email for discovery flow
 */
export function useSendSmsOtp() {
    const sendSmsOtp = useStytchSmsOtpSend();
    return useCallback(async (data) => {
        const result = await sendSmsOtp(data);
        if (result.success) {
            return {
                success: true,
                requestId: result.requestId,
                statusCode: result.statusCode,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
                data: result.data,
            };
        }
    }, [sendSmsOtp]);
}
/**
 * Authenticate with an MFA recovery (backup) code in place of TOTP/SMS — usable
 * during a forced-login MFA challenge or with an active session.
 */
export function useRecoverWithRecoveryCode() {
    const recover = useStytchRecoveryCodesRecover();
    return useCallback(async (data) => {
        const result = await recover(data);
        if (result.success) {
            return {
                success: true,
                sessionJwt: result.sessionJwt,
                sessionToken: result.sessionToken,
                memberSession: result.memberSession,
                member: result.member,
                organization: result.organization,
                recoveryCodesRemaining: result.recoveryCodesRemaining,
                data: result.data,
            };
        }
        return {
            success: false,
            error: result.error,
            data: result.data,
        };
    }, [recover]);
}
/**
 * Regenerate the current member's recovery codes (invalidates the old set).
 * Requires an active member session.
 */
export function useRotateRecoveryCodes() {
    const rotate = useStytchRecoveryCodesRotate();
    return useCallback(async () => {
        const result = await rotate();
        if (result.success) {
            return {
                success: true,
                recoveryCodes: result.recoveryCodes,
                data: result.data,
            };
        }
        return {
            success: false,
            error: result.error,
            data: result.data,
        };
    }, [rotate]);
}
export function useAuthenticateSmsOtp() {
    const authenticateSmsOtp = useStytchSmsOtpAuthenticate();
    return useCallback(async (data) => {
        const result = await authenticateSmsOtp(data);
        if (result.success) {
            return {
                success: true,
                requestId: result.requestId,
                statusCode: result.statusCode,
                memberId: result.memberId,
                //  organizationId: result.organizationId,
                sessionJwt: result.sessionJwt,
                sessionToken: result.sessionToken,
                memberSession: result.memberSession,
                member: result.member,
                organization: result.organization,
                data: result.data,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
                data: result.data,
            };
        }
    }, [authenticateSmsOtp]);
}
